module.exports = __webpack_public_path__ + "media/message.26d8a294.mp3";